import { FormMessagesEnum } from 'Types/formMessages.types'

export const FORM_MESSAGES_MAP: Record<FormMessagesEnum, string> = {
  [FormMessagesEnum.REQUIRED]: 'FormMessage_required',
  [FormMessagesEnum.EMAIL]: 'FormMessage_email',
  [FormMessagesEnum.MAX_LENGTH]: 'FormMessage_maxLength',
  [FormMessagesEnum.MIN_LENGTH]: 'FormMessage_minLength',
}
